import "./IInvestDisclaimerComponent.scss";
import {IComponentOptions} from "angular";
import {UserConfig} from "../../types/UserConfig";

export const Disclaimer = "iinvestDisclaimer";

export function disclaimer(): IComponentOptions {
    return {
        templateUrl: "app/iinvest/disclaimer/IInvestDisclaimerComponent.html",
        controllerAs: "ctrl",
        controller: IInvestDisclaimerComponentController
    };
}

export class IInvestDisclaimerComponentController {

    /** @ngInject */
    public constructor(private userConfig: UserConfig) {

    }
}
